/* eslint-disable no-bitwise */
import * as React from "react";
import * as Survey from "survey-react";

import { PersonRequest } from "@plinknz/tah-website-elements";

import { BenefitForm } from "./benefit-form";
import { CustomerFormQuestionTypes } from "./customer-form-types";
import { createSurveyConfig } from "../../../service/forms/kirihimete-whanau-survey-config";
import { transformKirihimeteWhanauData } from "../../../utility/form-transforms/transform-kirihimete-whanau-data";

export const KirihimeteWhanauForm = () => {
  const transformData = (
    survey: Survey.ReactSurveyModel,
    member: PersonRequest
  ) => {
    return transformKirihimeteWhanauData(survey, member);
  };

  return (
    <BenefitForm
      createSurveyConfig={createSurveyConfig}
      transformData={transformData}
      questionTypes={
        CustomerFormQuestionTypes.AddressFinder |
        CustomerFormQuestionTypes.DatePicker
      }
    />
  );
};
